// extracted by mini-css-extract-plugin
export default {"button":"GoBackButton_button__H+TPG","container":"GoBackButton_container__0aNKQ"};